export const CREATE_NOTIFICATION = 'notification/CREATE_NOTIFICATION';
export const DISMISS_NOTIFICATION = 'notification/DISMISS_NOTIFICATION';



// WEBPACK FOOTER //
// ./src/redux/constants/notification.js